class ColorGenerator {
  colors: string[];
  defaultColors: string[];

  constructor(defaultColors: string[]) {
    this.colors = [...defaultColors];
    this.defaultColors = [...defaultColors];
  }

  getColor(): string {
    if (this.colors.length === 1) {
      this.colors = [...this.defaultColors];

      return this.colors[this.colors.length - 1] as string;
    }

    return this.colors.shift() as string;
  }

  reset() {
    this.colors = [...this.defaultColors];
  }
}

export default new ColorGenerator([
  '#5470c6',
  '#2b5d8a',
  '#305e5f',
  '#5c8c67',
  '#abde8f',
  '#9cbf85',
  '#f9ce6d',
  '#f7b260',
  '#f5935d',
  '#ea7ccc',
  '#91cc75',
  '#7ebf6f',
  '#a6cd8c',
  '#68a667',
  '#c7e087',
  '#bcd77f',
  '#fac858',
  '#f2c44a',
  '#ee6666',
  '#d75452',
  '#73c0de',
  '#4d8fa5',
  '#6b9ca9',
  '#368b9b',
  '#89bed3',
  '#76aac1',
  '#3ba272',
  '#2e6d58',
  '#1f4838',
  '#5f7b87',
  '#fc8452',
  '#f96734',
  '#f5865e',
  '#f26f4f',
  '#fca17d',
  '#f89260',
  '#9a60b4',
  '#8e4f9d',
  '#b074b9',
  '#835391',
  '#ea7ccc',
  '#d365b6',
  '#dd83c7',
  '#d25ca8',
  '#df9dd2',
  '#c875a2',
  '#6f4b87',
  '#654176',
  '#7c5d95',
  '#5a3d6f',
  '#c6b0d2',
  '#b59cc5',
  '#c4aad3',
  '#a687af',
  '#d6c1e0',
  '#bfaed6',
  '#f5d28e',
  '#f4cd7f',
  '#f6d79a',
  '#f3da8e',
  '#a1d1a5',
  '#99c99b',
  '#b1dbb5',
  '#86b981',
  '#c2e0bf',
  '#b7d6af',
  '#f49390',
  '#f67c77',
  '#f88c8b',
  '#f47b75',
  '#7bcdc9',
  '#5fb3b1',
  '#71c0be',
  '#54a9a6',
  '#89d4d0',
  '#74bab8',
  '#c8c8c8',
  '#a7a7a7',
  '#b5b5b5',
  '#979797',
  '#4c78a8',
  '#3d5a80',
  '#405e90',
  '#4d6ca0',
  '#738cb9',
  '#607ca9',
  '#9ecae1',
  '#89b5da',
  '#96c0e5',
  '#7aa6d3',
  '#b3b3b3',
  '#979797',
  '#a2a2a2',
  '#8b8b8b',
  '#ffd92f',
  '#ffdb47',
  '#ffe15b',
  '#ffde3e',
  '#ffd156',
  '#ffcc34',
  '#6b4c86',
  '#564070',
  '#614b7d',
  '#4e3e66',
  '#b15928',
  '#a45124',
  '#ba7f50',
  '#b26f3d',
  '#4dbeee',
  '#44aae4',
  '#70c6a4',
  '#56ab89',
  '#5eaf95',
  '#4a9b7c',
  '#f17cb0',
  '#eb679f',
  '#ffadc1',
  '#fa92ab',
  '#ffbc79',
  '#fba95a',
]);
